<!--
  single-page/10000/Page.vue — AI 안전지수 보조 안내/요약 페이지(/tab/10000/page).

  ★ 1차 파일럿 = 복잡한 대시보드 지양·안전한 요약형(정적 안내 중심).
  ★ 공용 boards/tab/Page.vue 는 board/value/isPrint props·v-model 을 전달하지 않음
     → 본 컴포넌트는 props 없이(board undefined) 렌더되어도 동작해야 함.
  ★ 사고예측/확률/사후 통계 없음. 안전지수는 근거·한계 동반 안내.
-->
<template>
  <div class="ai-safety-page">
    <h4>AI 안전지수 보조 — 안내</h4>
    <p>
      본 기능은 위험성평가 작성 단계에서 입력한 <strong>유해·위험요인과 빈도/강도</strong>를 바탕으로
      <strong>안전지수와 개선조치</strong>를 보조 제시합니다.
      <strong>사고를 예측하지 않으며</strong>, 위험을 미리 인지하고 예방을 지원하기 위한 도구입니다.
    </p>
    <ul class="notes">
      <li>안전지수는 단독으로 해석하지 말고 <strong>근거·한계와 함께</strong> 확인하세요.</li>
      <li>AI 개선조치는 <strong>사람이 채택/수정/반려</strong>한 뒤에만 반영됩니다(자동 승인 없음).</li>
      <li>결재 상신 후에는 AI 결과를 <strong>조회·참고만</strong> 합니다(문서 수정 불가).</li>
      <li>재해자 개인정보 등 민감정보는 입력으로 사용하지 않습니다.</li>
    </ul>
    <p class="howto">
      작성: 좌측 메뉴 → AI 안전지수 보조 → [작성] → 항목 입력 후 [AI 분석 실행] → 결과 검토 → 저장/상신.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AiSafetyAssistPage10000',
  // props 미수신 가능(공용 Page.vue 계약) — 데이터 의존 없는 정적 안내로 안전 동작.
}
</script>

<style scoped>
.ai-safety-page { padding: 16px; }
.notes { line-height: 1.8; }
.howto { color: #555; margin-top: 12px; }
</style>